import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getDeliveryLogListApi = async (query) => {
  const res = await Get(`${ApiPath.Delivery}/station/${query?.stationCode}`, query);
  return res.data;
};

export const createDeliveryLogApi = async (query) => {
  const res = await Post(`${ApiPath.Delivery}`, query);
  return res.data;
};

export const updateDeliveryLogApi = async (query) => {
  const res = await Put(`${ApiPath.Delivery}/${query?.id}`, query);
  return res.data;
};

export const getDeliveryLogApi = async (query) => {
  const res = await Get(`${ApiPath.Delivery}/${query?.deliveryId}`, query);
  return res.data;
};
